import { useSelector } from 'react-redux';
import { isSmallerSelector } from '../../layout/mediaquery';
import { Banner } from '../context/banner-context';

const useBannerHelpers = (
	{
		headerText,
		descriptionText,
		ctaText,
		foregroundImage1,
		foregroundImage2,
		textPosition,
		mobileLayoutType
	}: Banner,
	index: number
) => {
	const isSmall = useSelector(isSmallerSelector);
	let columnItemsCount = 0;

	const isAnyTextVisible = !!headerText || !!descriptionText || !!ctaText;

	const isAllImagesEnabled = !!foregroundImage1 && !!foregroundImage2;

	if (isAnyTextVisible) {
		columnItemsCount += 1;
	}

	if (foregroundImage1) {
		columnItemsCount += 1;
	}

	if (isAllImagesEnabled) {
		columnItemsCount += 1;
	}

	const isTextCentered = textPosition === 'CENTER';

	const isSingleItem = columnItemsCount <= 1;

	const isDesktop = !isSmall;

	const isHorizontal = isDesktop || (!isDesktop && mobileLayoutType !== 'VERTICAL');

	const shouldLazyLoad = index > 0;

	return {
		columnItemsCount,
		isAnyTextVisible,
		isAllImagesEnabled,
		isTextCentered,
		isSingleItem,
		isDesktop,
		isHorizontal,
		shouldLazyLoad
	};
};

export type BannerHelpers = ReturnType<typeof useBannerHelpers>;

export default useBannerHelpers;
